import { ApiProperty } from "@nestjs/swagger";

export class AnalyticsUnitRequest{
    @ApiProperty()
    unitId:number;
}